import { render, staticRenderFns } from "./DetailsTable2.vue?vue&type=template&id=33700e0b&"
import script from "./DetailsTable2.vue?vue&type=script&lang=js&"
export * from "./DetailsTable2.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTable2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports